import { IFieldForm } from "pages/read-documents/model/IFieldForm";
import { PaymentPackageState } from "shared/api/services";

export const fieldsFormExportedPackages = (packageStates: PaymentPackageState[] = []): IFieldForm[] => {
  return [
    {
      id: "exportDateRange",
      name: "exportDateRange",
      type: "datePicker",
      label: "Fecha de exportación",
      placeholder: "",
      testId: "exportDateRange",
      isEnable: true,
    },
    {
      id: "itemFormNit",
      name: "nit",
      type: "text",
      label: "NIT prestador de salud",
      placeholder: "Ingrese NIT",
      testId: "itemFormNit",
      isEnable: true,
    },
    {
      id: "itemFormPaymentConsecutive",
      name: "paymentConsecutive",
      type: "text",
      label: "Consecutivo de pago",
      placeholder: "Ingrese consecutivo",
      testId: "itemFormPaymentConsecutive",
      isEnable: true,
    },
    {
      id: "itemFormExportStatus",
      name: "exportStatus",
      type: "Select",
      label: "Estado",
      placeholder: "Seleccione estado",
      testId: "itemFormExportStatus",
      isEnable: true,
      options: packageStates.length > 0
        ? packageStates.map((state) => ({ id: state.name, name: state.name }))
        : [
            { id: "En proceso de pago", name: "En proceso de pago" },
            { id: "Pagado", name: "Pagado" },
            { id: "Anulado", name: "Anulado" },
          ],
    },
  ];
};
